import { useEffect, useState } from 'react';

function useMediaQuery(query: string, initial = false) {
  const [matches, setMatches] = useState(initial);

  useEffect(() => {
    const matcher = window.matchMedia(query);
    setMatches(matcher.matches);

    function checkIsSmall(event: MediaQueryListEvent) {
      setMatches(event.matches);
    }

    matcher.addListener(checkIsSmall);
    return () => matcher.removeListener(checkIsSmall);
  }, [query]);

  return matches;
}

export default useMediaQuery;
